import React from "react";
import { NavLink } from 'react-router-dom'
import Shimmer from "./Shimmer";
import { useQuery } from "@tanstack/react-query";
import { getCatagoryAPI } from "./APIS";

function CatagoryHome() {
  const { isLoading, error, data:category } = useQuery({
    queryKey: ["category"],
    queryFn: getCatagoryAPI,
  });
  if (error) return <div>{error.message}</div>;
  return (
    <div className="full-cat home-full-cat">
      <div className="container">
        <div className="row">
          {isLoading && (
            <div className="products">
              {Array.from({ length: 6 }, (_, index) => (
                <Shimmer key={index} />
              ))}
            </div>
          )}

          {category && category.map((cat, i) => (
            <div className="col col3" key={i}>
              <div className="cat-wrap">  
              <NavLink title={cat.name} to={`category/${cat.parent_id ? cat.parent_details.slug+"/"+cat.slug : cat.slug}`}>           
                  <div className="cat-img">
                    <img 
                      src={`${process.env.REACT_APP_IMAGE_URL}${
                        cat.icon ? "category" : "product/thumbnail"
                      }/${
                        cat.icon
                          ? cat.icon
                          : cat.products_images
                          ? cat.products_images
                          : "placeholder/cat.png"
                      }`}
                      alt={cat.name} width={500} height={700} loading="lazy" 
                      /* style={{backgroundImage:`url(${process.env.REACT_APP_IMAGE_URL}${
                        cat.icon ? "category" : "product/thumbnail"
                      }/${
                        cat.icon
                          ? cat.icon
                          : cat.products_images
                          ? cat.products_images
                          : "placeholder/cat.png"
                      })`}} */
                    />                   
                  </div>
                </NavLink> 
                <h2>
                <NavLink title={cat.name} to={`category/${cat.parent_id ? cat.parent_details.slug+"/"+cat.slug : cat.slug}`}>{cat.name}</NavLink> 
                </h2>
                <div className="shop-btn">
                <NavLink title={cat.name} to={`category/${cat.parent_id ? cat.parent_details.slug+"/"+cat.slug : cat.slug}`}>SHOP NOW</NavLink> 
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default CatagoryHome;
